import React from 'react';
import Message from './Message';

class Main extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false,
            errorText: "",
            success: false,
            addedToNewsletter: false,
            addedToPanel: false,
            addedToEvents: false
        }
    }

    invalidToken() {
        return !this.props.token || this.props.token.length < 8;
    }

    componentDidMount() {
        if (this.invalidToken()) return;

        var that = this;
        that.setState({ loading: true});

        fetch( that.props.targetUrl + "confirm/" + that.props.req + "/" + that.props.token, {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': window.location.protocol + "//" + window.location.host,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
            }).then(function(response){
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return response.json().then(function(res){
                var error = new Error();
                error.response = res.text;
                throw error;
                });
            }
            }).then(function(data){
                that.setState({loading: false, success: true, addedToNewsletter: data.newsletter, addedToPanel: data.panel, addedToEvents: data.events, text: data.text})
            }).catch(function(error){
                that.setState({loading: false, error: true, errorText: error.response});
        });
    }

    render() {
        const invalidToken = this.invalidToken();
        
        var display = {
            loading: this.state.loading
        };

        if (invalidToken){
            display.header = "Ungültiges Registrierungs-Token";
            display.message = "Das Registrierungs-Token ist ungültig.";
        }else if (this.state.loading){
            display.header = "Ihre Anfrage wird bearbeitet - bitte einen Moment Geduld";
        }else if (this.state.error){
            display.header = "Es ist ein Fehler aufgetreten";
            if (this.state.errorText){
                display.message = this.state.errorText;
            }else{
                display.message = "Ihre Anfrage konnte leider nicht verarbeitet werden. Bitte versuchen Sie es in einigen Minuten erneut.";
            }
        }else if (this.state.success){
            display.header = "Registrierung abgeschlossen";
            display.message = "Vielen Dank für Ihr Interesse. ";

            let tmp = [];

            if (this.state.addedToNewsletter)
            {
                tmp.push("unseren Fuhrpark-Newsletter");
            }
            if (this.state.addedToPanel) {
				tmp.push("unser Online-Panel");
			}
            if (this.state.addedToEvents)
            {
                tmp.push("unseren Veranstaltungs-Verteiler");
            }

            if (tmp.length === 1)
            {
				display.message = "Sie haben sich erfolgreich für " + tmp[0] + " angemeldet";
            }
			else if (tmp.length === 2)
            {
				display.message = "Sie haben sich erfolgreich für " + tmp[0] + " und " + tmp[1] + " angemeldet";
            }
			else if (tmp.length === 3)
			{
				display.message = "Sie haben sich erfolgreich für " + tmp[0] + ", " + tmp[1] + " und " + tmp[2] + " angemeldet";
			}
			else if (this.state.text){
				display.message = this.state.text;
			}else{
				display.message = "Sie sind bereits registriert.";
			}
        }

        return (
            <Message loading={display.loading} header={display.header} message={display.message} />
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js